import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PrivacyPolicyEN,
  PrivacyPolicyES,
  PrivacyPolicyRU,
  PrivacyPolicyRO,
  PrivacyPolicyPT
} from './PrivacyPolicyContent';
import GamePageLayout from '../Layout/GamePageLayout';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Map of language-specific privacy policy content components
  const privacyPolicyComponents = {
    en: PrivacyPolicyEN,
    es: PrivacyPolicyES,
    ru: PrivacyPolicyRU,
    ro: PrivacyPolicyRO,
    pt: PrivacyPolicyPT,
  };

  // Get the appropriate component based on current language, fallback to English
  const PrivacyPolicyContent = privacyPolicyComponents[currentLanguage as keyof typeof privacyPolicyComponents] || PrivacyPolicyEN;

  return <GamePageLayout title={t('footer.privacyPolicy')} showFooter={true} showHowToPlay={false} wide={true}>
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
      <PrivacyPolicyContent />
    </div>
  </GamePageLayout>
};

export default PrivacyPolicy;